const initialState = {
    responseLandingList: {},
    responseLanding: {}
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "LANDING_CITIES_LIST_RESPONSE":
            newState.responseLandingList = action.value
            break;
        case "LANDING_CITIES_RESPONSE":
            newState.responseLanding = action.value
            break;
        case "UPLOAD_IMAGE_BACKOFFICE_RESPONSE":
            newState.responseUploadImage = action.value
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;